import React from 'react'
import { InfoWindow } from 'react-google-maps';
import { Link } from "gatsby"


class  LocationInfoWindow extends React.Component {

    toggle = () => {
    this.props.toggleOpen(this);
    }

    render() {

        const { name, address, slug } = this.props.data;
        return (
            <InfoWindow onCloseClick={this.toggle}>
            { slug ? 
                <div><Link to={`/${slug}`}style={{borderBottom: "2px solid rgb(255, 0, 0)", lineHeight: '1.8'}}><strong>{name}</strong></Link><div>{address}</div></div> :
                <div><strong>{name}</strong><br></br>{address}</div> }
            </InfoWindow>
     );
  }
}


export default LocationInfoWindow;